import {
  UniqueBnDev,
  SessionDistribution,
  UniqueBookings,
  UniqueBought,
  TrafficSource
} from './components'

const Main = () => {
  return (
    // do not remove flex-grow, it is used to fill the remaining space
    <div className="flex-grow" style={{ width: "75%" }}>
      <div className="my-3 p-3 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <UniqueBnDev display={"dashboard"} />
          <SessionDistribution display={"dashboard"} />
          <UniqueBookings />
          <UniqueBought />
          <div className="lg:col-span-2">
            <TrafficSource />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
